module.exports = __webpack_public_path__ + "img/livep.f5695e23.svg";